import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu/NavMenu';
import { Footer } from './Footer/Footer';
import { navbarDetails } from '../config/AppConfigurator';
export class Layout extends Component {
  static displayName = Layout.name;


  render() {
    return (
      <>
        <NavMenu {...navbarDetails} />
        <div className="main-container-box">
          <Container>
            {this.props.children}
          </Container>
        <Footer />
        </div>
      </>
    );
  }
}
